import React, { Component } from 'react';
import { CommonlyHeadMembers } from '../../common/headnav';
import * as services from '../../projects/services';
import { List, Toast, InputItem } from 'antd-mobile';
import { createBrowserHistory } from "history";
import './style.less';
import { Button } from 'antd';

const history = createBrowserHistory();
export default class ChangeIdentityNo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            identityNo: '',
            realName: '',
        }
        this.handleChangeIdentityNo = this.handleChangeIdentityNo.bind(this);
        this.handleChangeRealName = this.handleChangeRealName.bind(this);

    }
    componentDidMount()
    {
     
    }
    cancel = () => {
        history.goBack();
    }
    verification = () => {
        var idcardReg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
        if (this.state.realName === '') {
            Toast.info('真实姓名不能为空！', 1);
            return false;
        }
        if (this.state.identityNo === '') {
            Toast.info('身份证号码不能为空！', 1);
            return false;
        }
        if (!idcardReg.test(this.state.identityNo)) {
            Toast.info('身份证号码格式错误！', 1);
            return false;
        }



        return true;
    }
    ModifyIdentityNo = () => {
        if (!this.verification()) {
            return false;
        }
        let parameter = { oldLoginName:this.state.realName,newLoginName: this.state.identityNo};    
           
        services.EditChangeLoginName(parameter, '正在执行，请稍后').then(data => {
  
            if (data.status === 0) {
                localStorage.removeItem('QUANREN_SSO_MM_USER_CACHE');
                services.GetUserClaims('').then(data => {
                    if (data.status === 0) {
                        localStorage.setItem('QUANREN_SSO_MM_USER_CACHE', JSON.stringify(data.result));   
                                   
                    }
                });
                Toast.success(data.message, 1, () => {
                    history.push(`/members/settings`);
                    history.go();
                });
            } else {
                Toast.offline(data.message,2);
            }
        })
    }
    handleChangeRealName = (e) => {
        this.setState({ realName: e });
    }
    handleChangeIdentityNo = (e) => {
        this.setState({ identityNo: e });
    }

    render() {

        return <div className="editForm">
            <CommonlyHeadMembers barname="身份证绑定" />
            <List >
                <InputItem
                    type="text"
                    clear name="realName"
                    placeholder="请输入您的旧身份证" onChange={this.handleChangeRealName}
                >真实姓名</InputItem>
                <InputItem
                    type="text"
                    clear name="identityNo"
                    placeholder="请输入您的身份证号码" onChange={this.handleChangeIdentityNo}
                >身份证</InputItem>
                
                <div className="butdiv"><Button onClick={this.cancel}>取消</Button><Button className="ok" onClick={this.ModifyIdentityNo}>确定修改</Button></div>

            </List>
        </div>;
    }
}